import React from 'react';
import styled from 'styled-components';
import { FlexContainer } from 'app/styles/content';
import { COLORS, SIZES } from '@fupa/fupa-uikit';
const Bar = styled(FlexContainer).withConfig({
  componentId: "sc-khwgy4-0"
})(["height:", ";width:", ";background-color:", ";"], SIZES['2'], SIZES['72'], COLORS.lightGrey);
const Progress = styled.span.withConfig({
  componentId: "sc-khwgy4-1"
})(["height:100%;display:inherit;background-color:", ";width:", "%;max-width:100%;"], COLORS.fupaSecondary, props => props.progress);
export default function ProgressBar(_ref) {
  let {
    progress
  } = _ref;
  return /*#__PURE__*/React.createElement(Bar, {
    "data-sentry-element": "Bar",
    "data-sentry-component": "ProgressBar",
    "data-sentry-source-file": "ProgressBar.tsx"
  }, /*#__PURE__*/React.createElement(Progress, {
    "data-testid": "progress-bar",
    progress: progress,
    "data-sentry-element": "Progress",
    "data-sentry-source-file": "ProgressBar.tsx"
  }));
}
export { Progress };